var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.productComponent,_vm._g(_vm._b({tag:"component",attrs:{"data-qa":"productThumb","data-test":_vm.display,"has-vanishing-tag":_vm.hasVanishingTag},on:{"click":_vm.storeItem}},'component',_vm.propsToBind,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }